/*
 * sk-consent-ui.js — Consentmo-Cookie-Banner kompakt + klare Texte (theme-seitig, 2026-09-25).
 * Consentmo rendert in ein offenes Shadow-DOM (<csm-cookie-consent>). Dieses Skript
 *  - hängt ein <style> in das Shadow-Root: erste Ebene als Bottom-Sheet (Mobile) bzw. kleine Karte unten links (ab 768 px),
 *    Kategorie-Schalter der ersten Ebene ausgeblendet (sie liegen weiterhin unter „Einstellungen“),
 *    „Ablehnen“ und „Alle akzeptieren“ als gleich große Buttons;
 *  - ersetzt Titel, Hinweistext und Button-Beschriftungen durch übersetzte Texte (sk.cookie.*, alle 8 Sprachen);
 *  - korrigiert im Einstellungs-Dialog Titel + Buttons („Reject All“ war unübersetzt);
 *  - blendet die Chat-Bubble aus, solange der Banner offen ist (sie lag über den Buttons).
 * Rückbau: Skript-Tag in layout/theme.liquid entfernen → Consentmo zeigt wieder seine Admin-Einstellungen.
 */
(function () {
  'use strict';
  var script = document.currentScript;
  if (!script) return;
  var d = script.dataset;
  var T = {
    title: d.title, text: d.text, accept: d.accept, deny: d.deny, settings: d.settings,
    prefsTitle: d.prefsTitle, denyAll: d.denyAll, save: d.save
  };

  var CSS = [
    '.csm-dialog.csm-ccd-panel.sk-csm{position:fixed!important;top:auto!important;left:0!important;right:0!important;bottom:0!important;transform:none!important;',
    'width:100%!important;max-width:100%!important;height:auto!important;max-height:80vh!important;margin:0!important;',
    'padding:18px 16px calc(14px + env(safe-area-inset-bottom))!important;border-radius:16px 16px 0 0!important;',
    'box-shadow:var(--sk-shadow-xl)!important;overflow-y:auto!important;display:flex!important;flex-direction:column!important;gap:10px!important;',
    'background:var(--sk-bg-white)!important;color:var(--sk-text)!important;font-family:var(--sk-font-body)!important;}',
    '.sk-csm .csm-ccd-header-wrapper{padding:0!important;margin:0!important;border:0!important;}',
    '.sk-csm .csm-ccd-header-text{font-family:var(--sk-font-heading)!important;font-size:16px!important;font-weight:700!important;line-height:1.3!important;color:var(--sk-primary)!important;text-align:left!important;}',
    '.sk-csm .csm-ccd-body{padding:0!important;margin:0!important;gap:12px!important;}',
    '.sk-csm .csm-ccd-body-info{padding:0!important;margin:0!important;}',
    '.sk-csm .csm-ccd-body-info .csm-ccd-category-wrapper{display:none!important;}',
    '.sk-csm .csm-ccd-cookie-text,.sk-csm .csm-ccd-cookie-text>div{text-align:left!important;}',
    '.sk-csm .cc-message,.sk-csm #isense-cc-cookie-bar-text{font-family:var(--sk-font-body)!important;font-size:13.5px!important;line-height:1.45!important;color:var(--sk-text-secondary)!important;margin:0!important;}',
    '.sk-csm .cc-link{display:inline!important;padding:0!important;font-size:13.5px!important;color:var(--sk-primary)!important;text-decoration:underline!important;}',
    '.sk-csm .csm-ccd-buttons-wrapper{padding:0!important;margin:0!important;}',
    '.sk-csm .cc-compliance{display:grid!important;grid-template-columns:1fr 1fr!important;gap:8px!important;width:100%!important;}',
    '.sk-csm .cc-btn{display:flex!important;align-items:center!important;justify-content:center!important;width:100%!important;min-height:46px!important;height:auto!important;margin:0!important;padding:8px 10px!important;',
    'border-radius:8px!important;font-family:var(--sk-font-heading)!important;font-size:14px!important;font-weight:700!important;line-height:1.2!important;box-shadow:none!important;}',
    '.sk-csm .cc-btn .csm-arp-btn-text{color:inherit!important;font:inherit!important;}',
    '.sk-csm .cc-deny{order:1!important;background:var(--sk-bg-white)!important;color:var(--sk-primary)!important;border:2px solid var(--sk-primary)!important;}',
    '.sk-csm .cc-allow{order:2!important;background:var(--sk-primary)!important;color:var(--sk-bg-white)!important;border:2px solid var(--sk-primary)!important;}',
    '.sk-csm .cc-settings{order:3!important;grid-column:1 / -1!important;min-height:38px!important;background:transparent!important;border:0!important;',
    'color:var(--sk-primary)!important;font-family:var(--sk-font-body)!important;font-weight:600!important;text-decoration:underline!important;}',
    '@media (min-width:768px){.csm-dialog.csm-ccd-panel.sk-csm{left:24px!important;right:auto!important;bottom:24px!important;width:420px!important;border-radius:16px!important;padding:20px!important;}}'
  ].join('');

  function setText(el, txt) {
    if (el && txt && el.textContent !== txt) el.textContent = txt;
  }
  function setBtn(btn, txt) {
    if (!btn || !txt) return;
    setText(btn.querySelector('.csm-arp-btn-text') || btn, txt);
  }
  function isOpen(el) {
    if (!el) return false;
    var r = el.getBoundingClientRect();
    return r.height > 0 && r.width > 0 && getComputedStyle(el).display !== 'none' && getComputedStyle(el).visibility !== 'hidden';
  }

  function patch(sr) {
    if (!sr.getElementById('sk-csm-style')) {
      var st = document.createElement('style');
      st.id = 'sk-csm-style';
      st.textContent = CSS;
      sr.appendChild(st);
    }
    var dlg = sr.querySelector('.csm-dialog.csm-ccd-panel');
    if (dlg) {
      if (!dlg.classList.contains('sk-csm')) dlg.classList.add('sk-csm');
      setText(dlg.querySelector('.csm-ccd-header-text'), T.title);
      setText(dlg.querySelector('#isense-cc-cookie-bar-text'), T.text ? T.text + ' ' : '');
      setBtn(dlg.querySelector('.cc-allow'), T.accept);
      setBtn(dlg.querySelector('.cc-deny'), T.deny);
      setBtn(dlg.querySelector('.cc-settings'), T.settings);
    }
    var prefs = sr.querySelector('.cc-settings-dialog');
    if (prefs) {
      setText(prefs.querySelector('#cookie_settings_header'), T.prefsTitle);
      setBtn(prefs.querySelector('.cc-deny'), T.denyAll);
      setBtn(prefs.querySelector('.cc-settings'), T.save);
      setBtn(prefs.querySelector('.cc-allow'), T.accept);
    }
    document.documentElement.classList.toggle('sk-consent-open', isOpen(dlg) || isOpen(prefs));
  }

  function watchHost(host) {
    if (host.__skConsent) return;
    host.__skConsent = true;
    var tries = 0;
    (function withRoot() {
      var sr = host.shadowRoot;
      if (!sr) {
        if (tries++ < 600) requestAnimationFrame(withRoot);
        return;
      }
      patch(sr);
      new MutationObserver(function () { patch(sr); }).observe(sr, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style'] });
      // Nach dem Klick auf einen Button schließt Consentmo den Dialog (teils per Animation) → Status nachziehen
      sr.addEventListener('click', function () { setTimeout(function () { patch(sr); }, 400); }, true);
    })();
  }

  function find() {
    var host = document.querySelector('csm-cookie-consent');
    if (host) { watchHost(host); return true; }
    return false;
  }
  if (!find()) {
    var mo = new MutationObserver(function () { if (find()) mo.disconnect(); });
    mo.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function () { mo.disconnect(); }, 30000);
  }
})();
